import { useDispatch } from "react-redux"

import { bindActionCreators } from "@reduxjs/toolkit"

import { actions } from "./scrollSlice"

export function useScrollActions() {
  const dispatch = useDispatch()
  return bindActionCreators(actions, dispatch)
}
